module.exports = __webpack_public_path__ + "media/images/icons/gf-mod-chevron_right-rounded-88d7b7cba3f59015c0f88613e31ae3da.svg";